import { render, staticRenderFns } from "./TrDropdown.vue?vue&type=template&id=31dc8409&scoped=true"
import script from "./TrDropdown.vue?vue&type=script&lang=ts"
export * from "./TrDropdown.vue?vue&type=script&lang=ts"
import style0 from "./TrDropdown.vue?vue&type=style&index=0&id=31dc8409&prod&lang=scss&scoped=true"
import style1 from "./TrDropdown.vue?vue&type=style&index=1&id=31dc8409&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dc8409",
  null
  
)

export default component.exports